import ProcessScheduleSampleModel from "@/models/lab/ProcessScheduleSampleModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class ProcessScheduleSampleCollection extends LabServiceCollection {
  model() {
    return ProcessScheduleSampleModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddDesc('order');
    
    return CollectionFilter;
  }

}
